import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import bankingLocationActions from '../actions/bankingLocation';

function getSupportedSites(store) {
    request.get(`/${config.url_prefix}/api/getSupportedSites`)
        .end((error, response) => {
            if (error) {
                store.dispatch(bankingLocationActions.alertError('internal.server.error'));
            } else {
                try {
                    const res = JSON.parse(response.text);
                    store.dispatch(bankingLocationActions.getSupportedSitesSuccess(res.supportedCountries, res.primarySiteMap));
                } catch (exp) {
                    store.dispatch(bankingLocationActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getSupportedSites;
